import { ModalFactory } from '@rendora/common/features/modals/factory';
import { getI18nService } from '@rendora/common/services/i18n';
import CreateTeamLimitModal from './CreateTeamLimitModal.vue';

export const createTeamLimitModalSymbol = Symbol('create-team-limit-modal');

export const showCreateTeamLimitModal = () => {
  const i18nService = getI18nService();
  const $t = i18nService.t;
  ModalFactory.create(
    {
      title: $t('qi-ye-ti-yan-ban-zhang-hao-da-dao-shang-xian'),
      content: <CreateTeamLimitModal />,
    },
    createTeamLimitModalSymbol,
  );
};
